module.exports = __webpack_public_path__ + "static/neon-large-a77298be5f0247e3c3122ea28c436f94.png";